import axiosInstance from 'src/common/axiosInstance';
import { parseConnection, connectionSnapshot } from 'src/common/whatsappConnection';

// AUTO-WA-39 broadcasts API (WhatsApp backend, per connected number).
const base = (phoneNumberId) => `/phone-numbers/${phoneNumberId}/broadcasts`;

export const currentConnection = () => parseConnection(connectionSnapshot());

const broadcastApi = {
  list: (phoneNumberId, params = {}) => axiosInstance.get(base(phoneNumberId), { params }).then((r) => r.data),
  templates: (phoneNumberId) => axiosInstance.get(`${base(phoneNumberId)}/templates`).then((r) => r.data.data || []),
  audience: (phoneNumberId, audience) => axiosInstance.post(`${base(phoneNumberId)}/audience`, { audience }).then((r) => r.data.data),
  create: (phoneNumberId, body) => axiosInstance.post(base(phoneNumberId), body).then((r) => r.data.data),
  show: (phoneNumberId, id) => axiosInstance.get(`${base(phoneNumberId)}/${id}`).then((r) => r.data.data),
  recipients: (phoneNumberId, id, params = {}) => axiosInstance.get(`${base(phoneNumberId)}/${id}/recipients`, { params }).then((r) => r.data),
  cancel: (phoneNumberId, id) => axiosInstance.post(`${base(phoneNumberId)}/${id}/cancel`).then((r) => r.data.data),
  test: (phoneNumberId, body) => axiosInstance.post(`${base(phoneNumberId)}/test`, body).then((r) => r.data.data),
};

export default broadcastApi;

// Laravel 422 { errors: { field: [msg] } } -> { field: msg }, plus a summary line.
export function readErrors(error) {
  const status = error?.response?.status;
  const data = error?.response?.data || {};
  if (status === 403) return { summary: data.message || 'Only organisation owners and administrators can send broadcasts.', fields: {}, forbidden: true };
  const fields = Object.fromEntries(Object.entries(data.errors || {}).map(([key, value]) => [key, Array.isArray(value) ? value[0] : String(value)]));
  return { summary: data.message || 'Something went wrong. Nothing was sent; try again.', fields };
}
